/* eslint-disable no-console */
/* eslint-disable operator-linebreak */
/* eslint-disable no-shadow */
import { CHECKOUT_DECISION } from '../actionTypes';
import { addVerificationCheckoutUid, addCheckoutAll, sendError, changeRoute, addAaronsReferral } from '../actions';
import { segmentEvent } from '../../helpers/sendEvent';
import { isRenderableApproval } from '../../helpers/aaronsReferral';

const checkoutDecision = reduxStore => next => action => {
  if (action.type === CHECKOUT_DECISION) {
    const response = action.payload.response;
    const store = reduxStore.getState();
    if (response) {
      if (response.uid) {
        reduxStore.dispatch(addVerificationCheckoutUid(response.uid));
        reduxStore.dispatch(addCheckoutAll(response));
        if (
          store.loanInfo.billingState === 'IN' &&
          !store.loanInfo.confirmedWarrantyAgreement &&
          response.warranty_names &&
          response.warranty_names.length
        ) {
          reduxStore.dispatch(changeRoute('/warranty-agreement'));
        } else {
          reduxStore.dispatch(changeRoute('/display-offered-lease-details'));
        }
      } else if (response.new_decision?.approved === false) {
        reduxStore.dispatch(sendError(response));
        segmentEvent('page', 'Exceeded Limit', { approval_amount: store.loanInfo.availableLimit });
        if (isRenderableApproval(response.aarons)) {
          reduxStore.dispatch(addAaronsReferral(response.aarons));
          reduxStore.dispatch(changeRoute('/not-approved'));
        } else {
          reduxStore.dispatch(changeRoute('/support'));
        }
      } else if (response.status === 400 && response.reason?.includes('existing non-performing leases')) {
        console.log('checkout endpoint - existing non-performing leases, handled by caller');
      } else {
        reduxStore.dispatch(sendError(response));
        segmentEvent('page', 'General Error');
        reduxStore.dispatch(changeRoute('/support'));
      }
    }
  }

  return next(action);
};

export default checkoutDecision;
